import { wrapperFor } from './gateway';

/**
 * The chat's calls on sandbox: the server signs in with the client id and secret.
 *
 * This used to sign in from the browser, which meant Gatsby published the secret with
 * the page (WEB-1880). The sign-in now happens in /api/odin-gateway.
 */
const API = wrapperFor('default');

/* Kept because the chat imports it; a token set here would never leave the browser,
   and the server holds the only one that matters. */
export const setToken = (_token?: string) => undefined;

export default API;
